/**
 * @file Service for loading and providing of the configuration
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
var ConfigurationsService = /** @class */ (function () {
    /**
    * Creates an instance of ConfigurationsService.
    * @param {HttpClient} httpClient
    * @param {SettingsService} settingsService
    * @param {UserService} userService
    * @memberof ConfigurationsService
    */
    function ConfigurationsService(httpClient, userService) {
        this.httpClient = httpClient;
        this.userService = userService;
    }
    /**
    * Methode is part of Bootflow in app.module.ts
    */
    ConfigurationsService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadConfiguration()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationsService.prototype.loadConfiguration = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.get('configs/boot.' + this.userService.html5role + '.simplified.json').toPromise().then(function (configurations) {
                        _this.configurations = configurations;
                    })];
            });
        });
    };
    ConfigurationsService.prototype.configApp = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.configurations) {
                    throw new Error('No configurations loaded');
                }
                if (!this.configurations.app) {
                    throw new Error('App section is missing in the configuration');
                }
                return [2 /*return*/, this.configurations.app];
            });
        });
    };
    /**
    * Checks if the Notification (for current role) is part of the configuration
    */
    ConfigurationsService.prototype.hasNotifications = function () {
        if (!this.configurations) {
            return false;
        }
        if (!this.configurations.app) {
            return false;
        }
        if (!this.configurations.app.routes) {
            return false;
        }
        var notificationRoute = this.configurations.app.routes.find(function (route) { return route.name === 'Notification'; });
        if (!notificationRoute) {
            return false;
        }
        if (!notificationRoute.allowed.includes(this.userService.html5role)) {
            return false;
        }
        return true;
    };
    return ConfigurationsService;
}());
export { ConfigurationsService };
